export default "__VITE_ASSET__YqgJXQ4g__"